import { format, isValid, parse } from "date-fns";

export const dateToUsFormat = (value: string, timezoneLabel?: string) => {
  const date = parse(value, "yyyy-MM-dd HH:mm:ss", new Date());

  return isValid(date)
    ? `${format(date, "MM/dd/yyyy hh:mm a")} ${timezoneLabel ?? ""}`
    : "-";
};
